/**
 * Stringify anything that might land in a `catch (err)` block into a
 * human-readable message. Supabase's PostgrestError and RLS errors are
 * plain objects with `.message` — not `Error` instances — which is why
 * naive `String(err)` yields `[object Object]`.
 */
export function formatError(err: unknown): string {
  if (!err) return 'Unknown error';
  if (err instanceof Error) return err.message;
  if (typeof err === 'string') return err;

  if (typeof err === 'object') {
    const obj = err as Record<string, unknown>;
    // Supabase / PostgrestError shape: { message, details, hint, code }
    if (typeof obj.message === 'string' && obj.message) {
      const parts = [obj.message];
      if (typeof obj.details === 'string' && obj.details) parts.push(`(${obj.details})`);
      if (typeof obj.hint === 'string' && obj.hint) parts.push(`hint: ${obj.hint}`);
      return parts.join(' ');
    }
    try {
      return JSON.stringify(err);
    } catch {
      return '[unserialisable error]';
    }
  }

  return String(err);
}
